import type { SearchResultItem } from './SearchResultItem';
import type { OwaDate } from 'owa-datetime';
import type { ObservableMap } from 'mobx';

/**
 * Filter option applied before we search. Since the asset is responsible for defining how the search occurs,
 * no callback function here- consumer will be responsible for using the given filters on their search
 */
export type SearchFilterOption =
    | SearchFilterOptionDropdown
    | SearchFilterOptionCheckbox
    | SearchFilterOptionDatePicker;

export type SearchFilterOptionType = 'Dropdown' | 'Checkbox' | 'DatePicker';

export type SearchFilterOptionValue = string | boolean | OwaDate;

export interface SearchFilterOptionBase {
    id: string;
    label: string;
    type: SearchFilterOptionType;
    value?: SearchFilterOptionValue;
}

export interface SearchFilterOptionDropdown extends SearchFilterOptionBase {
    options: { key: string; text: string }[];
    value?: string;
    type: 'Dropdown';
}

export interface SearchFilterOptionCheckbox extends SearchFilterOptionBase {
    value?: boolean;
    type: 'Checkbox';
}

export interface SearchFilterOptionDatePicker extends SearchFilterOptionBase {
    value?: OwaDate;
    type: 'DatePicker';
}

export function getSearchFilterValue(
    filters: ObservableMap<string, SearchFilterOption> | null,
    id: string
): SearchFilterOptionValue | null {
    if (!filters) {
        return null;
    }

    const option = filters.get(id);

    if (option?.value !== undefined) {
        return option.value;
    }

    return null;
}

/**
 * Filter option applied to search results once results are returned. Since results are applied to the
 * items returned, provides a callback function to filter the returned items through.
 */
export interface ResultFilterOption {
    id: string;
    label: string;
    filter: (asset: SearchResultItem) => boolean;
    hideSelectionPill?: boolean;
}
